import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCommAuditTrails } from "../../../api/commAuditTrails_api";

export const getCommAuditTrailsAction = createAsyncThunk(
  "commAuditTrails/getCommAuditTrails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCommAuditTrails();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
